// numericText — comma-tolerant numeric text parsing, shared by the money and
// quantity input components and the finance form-state parsers. Values pasted
// from SAP / spreadsheets carry thousands separators ("1,234,567.89") which
// Number() alone rejects; grouping commas are stripped before parsing. Blank
// or unparseable text returns null so callers can distinguish "omitted" from
// "invalid" the same way parseMoney always has.

/** Parse numeric text, tolerating comma group separators. Returns null for
 *  blank or unparseable input. */
export function parseNumericText(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const ungrouped = trimmed.replace(/,/g, "");
  if (ungrouped === "") return null;
  const n = Number(ungrouped);
  return Number.isFinite(n) ? n : null;
}
